import { useReducer, useCallback } from 'react';
import { MSG_TYPE_OPEN_NOTIFICATION_SETTINGS_MODAL } from 'collaboration-sidebar/constants/IFrameMessageTypes';
const HANDLE_CLOSE = 'HANDLE_CLOSE';

function reducer(state, action) {
  switch (action.type) {
    case MSG_TYPE_OPEN_NOTIFICATION_SETTINGS_MODAL:
      return Object.assign({}, state, {
        show: true
      });

    case HANDLE_CLOSE:
      return Object.assign({}, state, {
        show: false
      });

    default:
      return state;
  }
}

export default function useNotificationSettingsModal() {
  const [{
    show
  }, dispatch] = useReducer(reducer, {
    show: false
  });
  const handleMessage = useCallback(({
    payload
  }) => dispatch(payload), []);
  const onClose = useCallback(() => dispatch({
    type: HANDLE_CLOSE
  }), []);
  return {
    handleMessage,
    onClose,
    show
  };
}